import styled, { keyframes } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-size: cover;
	background-position: center;
	padding: 64px 30px 0;
	transition: opacity 0.3s ease;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

const notificationKeyframes = keyframes`
	0% {
		transform: translateY(-125px);
	}
	100% {
		transform: translateY(0);
	}
`;

const StyledNotification = styled.div`
	display: grid;
	grid-template-columns: 40px 1fr auto;
	align-items: center;
	gap: 14px;
	width: 320px;
	height: 60px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 20px;
	padding: 0 20px 0 10px;
	transform: translateY(-125px);
	animation: ${notificationKeyframes} 0.3s ease-out 0.3s forwards;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledNotificationText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	${Text} {
		color: #ffffff;

		&:nth-child(1) {
			font-size: 14px;
			opacity: 0.5;
		}

		&:nth-child(2) {
			font-weight: 500;
			font-size: 16px;
		}
	}
`;

export { StyledContainer, StyledNotification, StyledNotificationText };
